var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';

var LinkLayout = function LinkLayout(_ref) {
  var _classnames;

  var children = _ref.children,
      isDiminishedHover = _ref.isDiminishedHover,
      isActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['children', 'isDiminishedHover', 'isActive']);

  return React.createElement(
    'span',
    _extends({
      className: classnames((_classnames = {}, _defineProperty(_classnames, styles.linkLayout, true), _defineProperty(_classnames, styles.linkActive, isActive), _defineProperty(_classnames, styles.linkDiminishedHover, isDiminishedHover), _classnames)),
      'data-hook': 'menu-navigation-link-wrapper'
    }, rest),
    children
  );
};

LinkLayout.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  isDiminishedHover: PropTypes.bool
};

export default LinkLayout;
//# sourceMappingURL=LinkLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/LinkLayout.js